

global.socketIo=  {
	socket:null,
	connected:false,
	connecting:false,
	authenticated:false,
	guest:true,
	connect:function() {
		/*
		 * Connects Socket IO
		 */
		if (this.connecting) {
			console.log('SocketIo - Already Connecting');
			return;
		}
		
		this.connecting=true;

		if (otuApp.isCordovaApp()) {
			console.log('SocketIo - Not Connecting App at the moment');
			this.connecting=false;
			return false;

		}

		if (typeof io==='undefined') {
			console.log('SocketIo - Not available');
			this.connecting=false;
			return false;
			}

		
		console.log('SocketIo - Trying to connect to socket');
		
		if (otuApp.isCordovaApp()) {
			this.socket=io(frameWork.options.socketIoUrl,{path:"/node/socket.io"});			
		} else {
			this.socket=io('',{path:"/node/socket.io"});			
		}
		
		/*
		 * Connect Handler
		 */
		this.socket.on('connect', function(){
			console.log('SocketIo - Connected');
			socketIo.connected=true;
			socketIo.authenticate();
			catchAWave.clearMessages();
		});	

		this.socket.on('disconnect', function(){
			console.log('SocketIo - Disconnected');
			socketIo.connected=false;
			socketIo.connecting=false;
			socketIo.authenticated=false;
			catchAWave.socketFailed();

		});	
		
		/*
		 *  Authenticate connection
		 */
		this.socket.on('authenticated', function() {
			  socketIo.authenticated=true;
			  console.log('SocketIO - Connection Authenticated');
			  
		  });
		
		/*
		 * 	Authenticate Logged in User 
		 */
		this.socket.on('authenticatedValidUser', function() {
			  socketIo.authenticated=true;
			  console.log('SocketIO - User Autheticated' );
			  // we refresh the appStae
			  socketIo.guest=false;
			  var url=otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=appStateRefresh';
			  otuApp.triggerAjaxGet(url,{attr:{"data-keep-animation":true,noSysInteraction:true}});			  	
		  });
		
		/*
		 * Unauthenticated User
		 */
		
		this.socket.on('unauthorized', function(err){
			  console.log("SocketIo - There was an authentication error:", err.message); 
		});
		
		/*
		 * Handle notifyMessage 
		 */
		
		this.socket.on('notifyMessage', function (data) {
			switch (data.message.type) {
				case messaging.chatMessage:
					messaging.handleChatMessage(data);
					break
				case messaging.highFiveMessage:
					messaging.handleHighFiveMessage(data);
					break;
				case messaging.shoutOutMessage:
					messaging.handleShoutOutMessage(data);
					break;
				case messaging.messageMessage:
					messaging.handleMessageMessage(data);
					break;					
										
				default:
					console.log('SocketIo - Unknown Message Received');
					console.log(data);
			}
		});
		
		/*
		 * handle the catchAWaveGame Messages
		 */
		this.socket.on('catchAWave', function (data) {
			console.log('SocketIo - catchAWaveMessage Received');
			console.log(data);
			switch (data.message.type) {
			case 'connectInvite':
				// we try the invitation screen
				catchAWave.connectInvite(data.message);
				break;
			default:
				console.log('SocketIo - Unknown Message Received');
				console.log(data);				
			
			}
		})
		
		/*
		 * handle the catchAWaveGame Messages
		 */
		this.socket.on('catchAWaveGameStateChange', function (data) {
			console.log('SocketIo - catchAWaveGameStateChange Received');
			console.log(data);
			// and we emit the state to the opponent
			catchAWave.connectUpdateGameState(data);
			
		})
		
		/*
		 * handle the catchAWaveGame Messages
		 */
		this.socket.on('catchAWaveGameInviteDeclinedAutomatically', function (data) {
			console.log('SocketIo - catchAWaveGameInviteDeclinedAutomatically');
			console.log(data);
			// and we emit the state to the opponent
			catchAWave.connectUpdateGameState(data);
			
		})		
		

		
	},
	/*
	 * Handle authentication
	 */
	authenticate: function (){
		if (!this.connected) return false;
		
		// reset guest
		if (!this.guest) this.guest=true;
		
		var req = { 
					username:'guest',
					token: otuApp.appUser.token,
					guest: otuApp.appUser.guest
			}	
		if (!otuApp.appUser.guest)
			req.username=otuApp.appUser.username;

        this.socket.emit('authentication', req);
		
		
	},
	emitMessageToRoom:function(message){
		//if (!socketIo.authenticated) return false;...
		if (socketIo.isConnected()) {
			console.log('SocketIo - Emitting Message to Room');
			console.log(message);
			socketIo.socket.emit('messageToRoom',message);
		} else {
			throw "SocketIO not Connected";
		}
	},
	isConnected:function() {
		return socketIo.connected && socketIo.socket.connected;
	}
	
}

